import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import profileIcon from '../../images/profileIcon.svg';
import searchIcon from '../../images/searchIcon.svg';
import SearchBarLocation from '../SearchBar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container } from 'react-bootstrap';
import './styles.css';

class Header extends Component {
  constructor() {
    super();
    this.state = {
      hidden: true,
    };
    this.title = this.title.bind(this);
    this.invertHidden = this.invertHidden.bind(this);
  }

  title(pathname) {
    let title = '';
    switch (pathname) {
    case '/comidas':
      title = 'Comidas';
      break;
    case '/bebidas':
      title = 'Bebidas';
      break;
    case '/explorar':
      title = 'Explorar';
      break;
    case '/explorar/comidas':
      title = 'Explorar Comidas';
      break;
    case '/explorar/bebidas':
      title = 'Explorar Bebidas';
      break;
    case '/explorar/comidas/ingredientes':
    case '/explorar/bebidas/ingredientes':
      title = 'Explorar Ingredientes';
      break;
    case '/explorar/comidas/area':
      title = 'Explorar Origem';
      break;
    case '/perfil':
      title = 'Perfil';
      break;
    case '/receitas-feitas':
      title = 'Receitas Feitas';
      break;
    case '/receitas-favoritas':
      title = 'Receitas Favoritas';
      break;
    default:
      title = '';
    }
    return (title);
  }

  invertHidden() {
    const { hidden } = this.state;
    if (hidden === true) {
      this.setState({ hidden: false });
    }
    if (hidden === false) {
      this.setState({ hidden: true });
    }
  }

  render() {
    const { location, history } = this.props;
    const { hidden } = this.state;
    const pageTitleText = this.title(location.pathname);

    return (
      <header className="header-glass-wrapper">
        <Container>
          <div className="header-top-bar">
            <button
              className="profile-button-custom"
              type="button"
              aria-label="Acessar perfil de usuário"
              onClick={ () => { history.push('/perfil'); } }
            >
              <img
                src={ profileIcon }
                alt="Ícone de perfil"
                data-testid="profile-top-btn"
              />
            </button>

            <div className="header-title-center" data-testid="page-title">
              <h2>{pageTitleText}</h2>
            </div>

            <div className="header-action-right">
              {
                (location.pathname === '/comidas'
                || location.pathname === '/bebidas'
                || location.pathname === '/explorar/comidas/area'
                || location.pathname === '/explorar/bebidas/area')
                  ? (
                    <button
                      className={`search-button-custom ${!hidden ? 'active' : ''}`}
                      type="button"
                      aria-label="Abrir ou fechar barra de pesquisa"
                      onClick={ () => this.invertHidden() }
                    >
                      <img
                        src={ searchIcon }
                        alt="Ícone de busca"
                        data-testid="search-top-btn"
                      />
                    </button>
                  ) : (
                    <div className="header-spacer" />
                  )
              }
            </div>
          </div>

          {
            (location.pathname === '/comidas'
            || location.pathname === '/bebidas'
            || location.pathname === '/explorar/comidas/area'
            || location.pathname === '/explorar/bebidas/area')
            && !hidden
            && (
              <div className="header-search-dropdown">
                <SearchBarLocation />
              </div>
            )
          }
        </Container>
      </header>
    );
  }
}

const HeaderLocation = withRouter(Header);
export default HeaderLocation;

Header.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

